export const configSSO = {
  issuer: 'https://sts.inforius.be',
  postLogoutRedirectUri: 'https://icrrappel.myinforius.be',
  redirectUri: 'https://icrrappel.myinforius.be/callback',
  clientId: 'icrrappel_e3',
  oidc: true,
  userinfoEndpoint: 'https://sts.inforius.be/connect/userinfo',
  useSilentRefresh: true,
  scope: 'openid icrrappel.e3_f',
  showDebugInformation: false,
  silentRefreshRedirectUri: 'https://icrrappel.myinforius.be/silent-renew.html',
  responseType: 'code',
  enableLogConsole: false,
};
